import store from 'store';
import { IArticlesItem, IEmailBrowserEmail } from './../Content/interfaces';
import { ACCOUNTS_NEWS, CURATION_HISTORY, SEARCH_ARTICLES, WHN_ARTICLES, MOST_ENGAGED, FAVORITE_NEWS } from 'constants/actionTypes';
import { addUrlParams, getImageUrl } from 'utils';
import { INewArticlesItem } from 'modules/Content/MyAccounts/interface';

export const getVersionId = () => {
  //get version id from url param or state
  const state = store.getState();
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let versionId = params.get('version_id');
  return versionId ? parseInt(versionId) : 0;
  // return versionId ? parseInt(versionId) : state.userEntities.versionId;
};

export const getQueryCampaignId = () => {
  // get campaign id from url param or state
  // const state = store.getState();
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let campaignId = params.get('campaign_id');
  return campaignId ? parseInt(campaignId) : 0;
};

export const getQueryEmailId = () => {
  // get campaign id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let emailId = params.get('email_id');
  return emailId ? parseInt(emailId) : 0;
};

export const getQueryGenerationId = () => {
  // get generation id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let generationId = params.get('generation_id');
  return generationId ? generationId : '';
};

export const getQueryWorkflowId = () => {
  // get campaign id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let workflowId = params.get('workflow_id');
  return workflowId ? parseInt(workflowId) : 0;
};

export const getQueryAssetId = () => {
  // get asset id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let assetId = params.get('email_id');
  return assetId ? parseInt(assetId) : 0;
};

export const getQueryVersionId = () => {
  // get version id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let versionId = params.get('version_id');
  return versionId ? parseInt(versionId) : 0;
};

export const getAnalyticsFilterId = () => {
  // get version id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let filterId = params.get('fs_id');
  return filterId ? parseInt(filterId) : 0;
};

export const getQueryAllCampaigns = () => {
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let allCampaigns = params.get('allCampaigns');
  return allCampaigns ?? 'false';
};

export const getQueryIsAIEmail = () => {
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let aiEmail = params.get('ai_email');
  return aiEmail ? true : false;
};

export const getQueryEmailIds = () => {
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let allEmails = params.get('email_id');
  return allEmails?.split(',').map(Number) ?? [];
};

export const getQueryExportPopup = () => {
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let exportPopup = params.get('exportPopup');
  return exportPopup ?? 'false';
};

export const getFromQueryString = (key: string) => {
  // get version id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let value = params.get(key);
  return value || '';
};

export const setArticleCuration = (articleId: number, add: boolean) => {
  if (add) {
    store.dispatch({
      type: WHN_ARTICLES.ADD_CURATE,
      curate_article_id: articleId,
    });
    store.dispatch({
      type: MOST_ENGAGED.ADD_CURATE,
      curate_article_id: articleId,
    });

    store.dispatch({
      type: FAVORITE_NEWS.ADD_CURATE,
      curate_article_id: articleId,
    });

    store.dispatch({
      type: SEARCH_ARTICLES.ADD_CURATE,
      curate_article_id: articleId ? articleId : null,
    });

    store.dispatch({
      type: ACCOUNTS_NEWS.ADD_CURATE,
      curate_article_id: articleId ? articleId : null,
    });

    store.dispatch({
      type: CURATION_HISTORY.ADD_CURATE,
      curate_article_id: articleId ? articleId : null,
    });
  } else {
    store.dispatch({
      type: WHN_ARTICLES.REMOVE_CURATE,
      curate_article_id: articleId ? articleId : null,
    });

    store.dispatch({
      type: SEARCH_ARTICLES.REMOVE_CURATE,
      curate_article_id: articleId ? articleId : null,
    });

    store.dispatch({
      type: ACCOUNTS_NEWS.REMOVE_CURATE,
      curate_article_id: articleId ? articleId : null,
    });

    store.dispatch({
      type: FAVORITE_NEWS.REMOVE_CURATE,
      curate_article_id: articleId,
    });

    store.dispatch({
      type: CURATION_HISTORY.REMOVE_CURATE,
      curate_article_id: articleId ? articleId : null,
    });
    store.dispatch({
      type: MOST_ENGAGED.REMOVE_CURATE,
      curate_article_id: articleId,
    });
  }
};

export const setCurationRemoveAll = () => {
  store.dispatch({
    type: WHN_ARTICLES.ADD_CURATE,
  });
  store.dispatch({
    type: MOST_ENGAGED.REMOVE_ALL_CURATE,
  });

  store.dispatch({
    type: FAVORITE_NEWS.REMOVE_ALL_CURATE,
  });

  // store.dispatch({
  //   type: SEARCH_ARTICLES.ADD_CURATE,
  // });

  store.dispatch({
    type: ACCOUNTS_NEWS.REMOVE_ALL_CURATE,
  });

  // store.dispatch({
  //   type: CURATION_HISTORY.ADD_CURATE,
  // });
};

export const updateArticleCurationState = (articles: INewArticlesItem[], articleId: number, add: boolean) => {
  let updated_articles = articles.map((item) => {
    if (articleId) {
      if (item.articleId === articleId) {
        item.isCurated = add;
      }
    } else {
      item.isCurated = false;
    }

    return item;
  });

  return updated_articles;
};

export const serializeEditionsForAssetBrowser = (jsonData: any): any => {
  let editions: any = [];
  for (let article of jsonData) {
    editions.push({
      edition_id: article.version_id,
      image: article.thumbnail[0],
      name: article.name,
      subject: article.subject,
      previewImage: article.previewImage || null,
      articles_count: article?.curated_articles_count,
      last_updated: article.last_update,
      status: article?.status,
    });
  }

  return editions;
};

// image: article.thumbnails[0],
// name: article.name,
// subject: article.subject,
// previewImage: article.previewImage || null,

export const serializeEmailBrowserEmails = (jsonData: any): IEmailBrowserEmail[] => {
  let emails: IEmailBrowserEmail[] = [];
  for (let email of jsonData) {
    emails.push({
      emailId: email['email_id'],
      name: email['email_name'],
      subject: email['subject'],
      articlesCount: email['articles_count'],
      campaignId: email['campaign_id'],
      campaignName: email['campaign_name'],
      thumbnails: email['image'] ?? [],
      lastUpdate: email['last_update'],
      createdOn: email['created_on'],
    });
  }

  return emails;
};

export const serializeEmailBrowserCuratedResponse = (jsonData: any): IEmailBrowserEmail => {
  let email: IEmailBrowserEmail = {
    emailId: jsonData['email_id'],
    name: jsonData['email_name'],
    subject: jsonData['subject'],
    articlesCount: jsonData['articles_count'],
    campaignId: jsonData['campaign_id'],
    campaignName: jsonData['campaign_name'],
    thumbnails: jsonData['image'],
    lastUpdate: jsonData['last_update'],
    createdOn: jsonData['created_on'],
  };

  return email;
};

export const addImagesInEmailItemCard = (email: any, articleIds: any): IEmailBrowserEmail => {
  let newEmail: IEmailBrowserEmail = { ...email };
  let thumbnails = [];
  let ids = articleIds?.split(',');
  console.log('ids : ', ids);
  if (ids) {
    ids.forEach((id: string) => {
      if (thumbnails.length < 3) {
        thumbnails.push(getImageUrl('', 95, 95, parseInt(id)));
      }
    });
  }
  return newEmail;
};
